































import Vue from 'vue';
import {ScheduleEventType} from '../../../models/ScheduleEventParam';
import Tab from '@/common/components/ui/Tab/index.vue';
import { DelayMode } from '../../../models/ScheduleDelay';
import TplTimeBox from './TplTimeBox.vue';
import CustomMsgTimeBox from './CustomMsgTimeBox.vue';
import scheduleRuleVuex from '../../../vuex/common';

function options(verifiedService: boolean, eventType: number) {
  if(verifiedService) {
    let msgText = '';
    let tplText = '';
    if(eventType === ScheduleEventType.Follow) {
      msgText = '48小时内';
      tplText = '48小时外';
    } else if (eventType === ScheduleEventType.RemarkAppended) {
      msgText = '使用客服消息触达';
      tplText = '使用模板消息触达';
    }
    return [
      {
        label: msgText,
        value: DelayMode.UseMsg,
      },
      {
        label: tplText,
        value: DelayMode.UseTpl,
      },
    ];
  } else {
    let msgText = '';
    if(eventType === ScheduleEventType.Follow) {
      msgText = '48小时内';
    } else if (eventType === ScheduleEventType.RemarkAppended) {
      msgText = '使用客服消息触达';
    }
    return [
      {
        label: msgText,
        value: DelayMode.UseMsg,
      },
    ];
  }
}
export default Vue.extend({
  mixins: [scheduleRuleVuex],
  components: {
    Tab,
    TplTimeBox,
    CustomMsgTimeBox,
  },
  data() {
    return {
      DelayMode,
      options,
      currMode: DelayMode.UseMsg,
      ScheduleEventType,
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.delayMode) {
        this.currMode = this.delayMode;
      }
    });

  },
  props: {
    eventTriggered: {
      type: Object,
      default: null,
    },
    delayMode:  {
      type: Number,
    },
  },
  computed: {
    isVerifiedService(): boolean {
      return this.accountState.account.weixinType === 1 &&
             this.accountState.account.isVerified;
    },
    showSelection(): boolean {
      return this.eventTriggered.eventType === ScheduleEventType.Follow
          || this.eventTriggered.eventType === ScheduleEventType.RemarkAppended;
    },
  },
  methods: {
    handleModeChange(mode: any): void {
      this.currMode = mode;
    },
    initTab(): void {
      if(this.$refs.modeTab) {
        (this.$refs.modeTab as any).initTab();
      }
    },
  },
});
